export default __webpack_public_path__ + "static/media/fuelEnDetailTablet.9e87c2f2.jpg";